import { AnnualReportComponent } from './annual-report/annual-report.component';
import { GalleryComponent } from './gallery/gallery.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ReportComponent } from './report/report.component';
import { SuggestionComplaintComponent } from './suggestion-complaint/suggestion-complaint.component';
import { NewsComponent } from './news/news.component';
import { LoanComponent } from './loan/loan.component';
import { DepositComponent } from './deposit/deposit.component';
import { BranchesComponent } from './branches/branches.component';
import { StaffComponent } from './staff/staff.component';
import { ManagementComponent } from './management/management.component';
import { ContactComponent } from './contact/contact.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { AtmFacilityComponent } from './atm-facility/atm-facility.component';


const routes: Routes = [
  { path: '', component: HomeComponent},
  { path: 'home', component: HomeComponent},
  { path: 'about', component: AboutUsComponent},
  { path: 'about/management', component: ManagementComponent},
  { path: 'about/staff', component: StaffComponent},
  { path: 'about/branches', component: BranchesComponent},
  { path: 'about/gallery', component: GalleryComponent},
  { path: 'about/annual-reports', component: AnnualReportComponent},
  { path: 'services/deposit', component: DepositComponent},
  { path: 'services/loan', component: LoanComponent},
  { path: 'about/news', component: NewsComponent},
  { path: 'suggestion-complaint', component: SuggestionComplaintComponent},
  { path: 'about/report', component: ReportComponent},
  { path: 'contact', component: ContactComponent},
  { path: 'feedback', component: FeedbackComponent},
  { path: 'services/atm', component: AtmFacilityComponent},

  { path: '404', component: PageNotFoundComponent}
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CmsRoutingModule { }
